import SingleEventModalInviteModerator from "./EventModalInviteModerator";
import SingleEventModalEndEvent from "./EventModalEndEvent";

export const EventModalInviteModerator = SingleEventModalInviteModerator;
export const EventModalEndEvent = SingleEventModalEndEvent;
